import { convertFileSrc, invoke, isTauri } from "@tauri-apps/api/core";

const CACHE_TTL_LABEL = "7天";

export type ImageCacheStats = {
  count: number;
  bytes: number;
  path: string;
};

function extFromUrl(url: string) {
  const path = url.split("?")[0].toLowerCase();
  if (path.endsWith(".png")) return "png";
  if (path.endsWith(".webp")) return "webp";
  return "jpg";
}

export function previewCacheName(id: string | number, url: string) {
  return `preview_${String(id).replace(/[^a-zA-Z0-9_-]+/g, "_")}.${extFromUrl(url)}`;
}

export function isDesktopImageCacheEnabled() {
  return Boolean(isTauri());
}

export async function getCachedPreviewImage(name: string) {
  if (!isDesktopImageCacheEnabled()) return null;
  try {
    const path = await invoke<string | null>("get_cached_preview_image", { name });
    return path ? convertFileSrc(path) : null;
  } catch {
    return null;
  }
}

export async function savePreviewImageToCache(name: string, url: string) {
  if (!isDesktopImageCacheEnabled()) return null;
  try {
    const res = await fetch(url);
    if (!res.ok) return null;
    const type = res.headers.get("content-type") || "";
    if (type && !type.toLowerCase().startsWith("image/")) return null;
    const buffer = await res.arrayBuffer();
    const path = await invoke<string>("save_cached_preview_image", { name, bytes: Array.from(new Uint8Array(buffer)) });
    return convertFileSrc(path);
  } catch {
    return null;
  }
}

export async function imageCacheStats() {
  if (!isDesktopImageCacheEnabled()) return null;
  try {
    return await invoke<ImageCacheStats>("image_cache_stats");
  } catch {
    return null;
  }
}

export async function clearImageCache() {
  if (!isDesktopImageCacheEnabled()) return null;
  try {
    return await invoke<ImageCacheStats>("clear_image_cache");
  } catch {
    return null;
  }
}

export function imageCacheSummary(stats: ImageCacheStats | null) {
  if (!stats) return `压缩图缓存：EXE 本机缓存 ${CACHE_TTL_LABEL}`;
  const mb = stats.bytes / 1024 / 1024;
  return `压缩图缓存：${stats.count} 张，${mb >= 1024 ? `${(mb / 1024).toFixed(2)} GB` : `${mb.toFixed(1)} MB`}，保存 ${CACHE_TTL_LABEL}`;
}
